import React from 'react';
import { Menubar, Root, Menu, Trigger, Portal, Item, Content } from '@radix-ui/react-menubar';
import { ItemMenuBar } from '@/types/menu';

interface MenuBarProps {
    menus: ItemMenuBar[],
    containerClassname?: string,
    itemClassname?: string,
    itemSelectedClassname?: string,
    onChangeMenu: Function
}

const MenuBar = ({ menus, containerClassname, itemClassname, itemSelectedClassname, onChangeMenu }: MenuBarProps) => {
    return (
        <Root className={`flex justify-around items-center content-center bg-bgMenubar ${containerClassname}`}>
            {menus && (
                menus.map((e) => {
                    return (
                        <div onClick={() => onChangeMenu(e.id)} key={e.id} className={`mx-1 w-full h-8 text-center rounded-1 content-center ${itemClassname} ${e.isSelected && itemSelectedClassname} `}>
                            <Menu>
                                <div>{e.label}</div>
                            </Menu>
                        </div>
                    );
                })
            )}
        </Root>
    );
};

export default MenuBar;
